import { render, staticRenderFns } from "./livestockSummary.vue?vue&type=template&id=1fca87bb&scoped=true&"
import script from "./livestockSummary.vue?vue&type=script&lang=js&"
export * from "./livestockSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca87bb",
  null
  
)

export default component.exports